import { apiClient } from '@/lib';
import type { LoginRequest, LoginResponse, MessageResponse, ProfileResponse } from '@/types';

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<LoginResponse>('/auth/login', data).then((r) => r.data),

  me: () => apiClient.get<ProfileResponse>('/auth/me').then((r) => r.data),

  changePassword: (data: { currentPassword: string; newPassword: string }) =>
    apiClient.post<MessageResponse>('/auth/change-password', data).then((r) => r.data),

  forgotPassword: (email: string) =>
    apiClient.post<MessageResponse>('/auth/forgot-password', { email }).then((r) => r.data),

  resetPassword: (token: string, newPassword: string) =>
    apiClient
      .post<MessageResponse>('/auth/reset-password', { token, newPassword })
      .then((r) => r.data),
};
